import { render, staticRenderFns } from "./NexelTroubleTicketModal.vue?vue&type=template&id=54e6d074&scoped=true"
import script from "./NexelTroubleTicketModal.vue?vue&type=script&lang=js"
export * from "./NexelTroubleTicketModal.vue?vue&type=script&lang=js"
import style0 from "./NexelTroubleTicketModal.vue?vue&type=style&index=0&id=54e6d074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e6d074",
  null
  
)

export default component.exports